import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useContext, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {format} from "date-fns";
import * as React from "react";
import {AuthContext} from "../../context/AuthContext";
import axios from "axios";
import {errorToast, successToast} from "../../components/layout/ToastStyles";

const IngresoList = () => {

  const {user} = useContext(AuthContext)
  const {loading, data, fetchData, error} = useFetch2( Apis.PROD + '/pedidos/ingresos', []);

  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const fechaValue = useCallback(cell => {
    if(cell.renderValue()){
      const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
      return format(fechaUTC, formatoFecha)
    } else return ''
  }, []);

  const montoValue = useCallback(cell =>
    <div style={{color: cell.row.original.estado === "Cancelado" ? cell.row.original.reembolso? "red" : "orange" : "blue"}}>{cell.renderValue().toFixed(2)}</div>
  , []);

  const reembolsoValue = useCallback(cell =>
    {return cell.row.original.estado != 'Cancelado' ? "No requerido" : (cell.renderValue() ? "Si" : "Falta")}
    , []);

  const reembolso = async (id, tipo) => {
    try {
      const {data} = await axios.post(Apis.PROD + '/pedidos/ingresos/' + tipo + '/' + id)
      if (data) successToast("Se ha actualizado el reembolso")
    } catch (error) {
      errorToast("Error al cambiar reembolso")
      console.log(error)
    }
    await fetchData()
  }

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        { user?.tipoUsuario !== 6 && !cell.row.original.reembolso &&
        <div>
          {cell.row.original.estado === "Cancelado" && <Button size='xs' variant='light' onClick={() => reembolso(cell.row.original.id,cell.row.original.tipo)}>Reembolsar</Button>} </div>
        }
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [user]);

  const columns = useMemo(
    () => [
      {
        header: 'Tipo',
        accessorKey: 'tipo'
      },
      {
        header: 'Codigo',
        accessorKey: 'codigo'
      },
      {
        header: 'Correo',
        accessorKey: 'correo',
      },
      {
        header: 'Monto',
        accessorKey: 'monto',
        cell: montoValue
      },
      {
        header: 'Fecha',
        accessorKey: 'fecha',
        cell: fechaValue
      },
      {
        header: 'Estado',
        accessorKey: 'estado',
      },
      {
        header: 'Reembolsado',
        accessorKey: 'reembolso',
        cell: reembolsoValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Ingresos'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            noData='No existen ingresos'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
    </PageContainerFull>
  )
}

export default IngresoList
